var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pic"},[_c('img',{attrs:{"src":require("../../assets/images/zaiJiaTryv3.png")},on:{"click":_vm.goBusinessClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }